import {
    FETCH_USER_CONNECTS,
    LIST_USER_CONNECTS
} from "./types";

const init = {
    isLoading: false,
    list: [],
    totals: 0,
    page: 0,
    size: 50,
    filter: {
        page: 1,
        size: 50,
        username: "",
        type: "import"
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_USER_CONNECTS:
            return {
                ...state,
                isLoading: true,
                filter: payload
            };
        case LIST_USER_CONNECTS:
            return {
                ...state,
                isLoading: false,
                list: payload.list || [],
                totals: payload.totals ?? state.totals,
                page: payload.page ?? state.page,
                size: payload.size ?? state.size,
                filter: payload.filter || state.filter
            };
        default:
            return state;
    }
};
